<template>
  <div class="blocks mt-0">
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          v-model="blocks.name"
          :disabled="
            blocks.slug === 'welcome-message' ||
            blocks.slug === 'default-message'
          "
          class="solo-input block-title"
          @input="$store.dispatch('updateBlockName', blocks)"
        />
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn
          fab
          dark
          small
          color="primary"
          @click="$store.dispatch('setCopiedBlock', blocks)"
        >
          <v-icon dark>file_copy</v-icon>
        </v-btn>
        <v-btn
          :disabled="
            blocks.slug === 'welcome-message' ||
            blocks.slug === 'default-message'
          "
          fab
          dark
          small
          color="error"
          @click="deleteBlockDialog = true"
        >
          <v-icon dark>delete_outline</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <draggable
      v-model="blocks.payload"
      group="blocks"
      handle=".handle"
      @start="drag = true"
      :animation="300"
      ghost-class="moving-card"
      @end="drag = false"
    >
      <div
        v-for="(block, index) in blocks.payload"
        v-if="blocks.payload.length"
        class="block-item"
        :key="index"
      >
        <component
          v-model="cardsModels[index]"
          :is="getBlockName(block.block_id)"
          :data="block.data"
          :blocks-list="blocksList"
          :index="index"
          :slug="getBlockName(block.block_id)"
          :valid-data="validCardData(block)"
        >
          <supported-platforms
            slot="tail"
            :slug="getBlockName(block.block_id)"
          />
        </component>
        <div class="block-actions">
          <v-btn fab small color="" @click="setDeleteBlockCard(index)"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn
          >
          <v-btn class="handle" fab small color=""
            ><v-icon color="#666">height</v-icon></v-btn
          >
        </div>
      </div>
    </draggable>
    <v-dialog v-model="dialog" width="500">
      <delete-dialog
        title="this card"
        @closeDialog="dialog = false"
        @onDelete="deleteBlockCard(indexToDelete)"
      />
    </v-dialog>
    <v-dialog v-model="deleteBlockDialog" width="500">
      <delete-dialog
        :title="`block ${blocks.name}`"
        @closeDialog="deleteBlockDialog = false"
        @onDelete="deleteBlock"
      />
    </v-dialog>
    <add-block-buttons :blocks="blocks" />
  </div>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import cards from "../../../data/cards";
import common from "../../../utils/common";
import deleteDialog from "../../common/deleteDialog";
import addBlockButtons from "./add-block";
import cardBookAppointment from "./block-cards/book-appointment";
import cardAttachment from "./block-cards/card-attachment";
import cardAttribute from "./block-cards/card-attribute";
import cardAudio from "./block-cards/card-audio";
import cardBilling from "./block-cards/card-billing";
import cardCalenderBooking from "./block-cards/card-calender-booking";
import cardDateTimeInput from "./block-cards/card-date-time-input";
import cardEmail from "./block-cards/card-email";
import cardEndConversation from "./block-cards/card-end-conversation";
import cardEscalate from "./block-cards/card-escalate";
import cardFlight from "./block-cards/card-flight";
import cardFunnel from "./block-cards/card-funnel";
import cardGallery from "./block-cards/card-gallery";
import cardGif from "./block-cards/card-gif";
import cardGoBlock from "./block-cards/card-go-block";
import cardImage from "./block-cards/card-image";
import cardImageUrl from "./block-cards/card-image-url";
import cardJson from "./block-cards/card-json";
import cardMap from "./block-cards/card-map";
import cardMultiInput from "./block-cards/card-multi-input";
import cardOrder from "./block-cards/card-order";
import cardRandom from "./block-cards/card-random";
import cardSuggested from "./block-cards/card-suggested";
import cardText from "./block-cards/card-text";
import cardTravel from "./block-cards/card-travel";
import cardTyping from "./block-cards/card-typing";
import cardUserInput from "./block-cards/card-user-input";
import cardVideo from "./block-cards/card-video";
import cardWeather from "./block-cards/card-weather";
import SupportedPlatforms from "./SupportedPlatforms";
export default {
  name: "Blocks",
  components: {
    cardText,
    cardImageUrl,
    cardImage,
    cardGallery,
    cardVideo,
    cardGif,
    cardSuggested,
    cardGoBlock,
    cardAudio,
    cardTyping,
    cardAttribute,
    cardUserInput,
    cardJson,
    cardRandom,
    cardBilling,
    cardTravel,
    cardFlight,
    deleteDialog,
    addBlockButtons,
    draggable,
    cardWeather,
    cardMultiInput,
    cardMap,
    cardDateTimeInput,
    cardEscalate,
    cardEmail,
    cardAttachment,
    cardEndConversation,
    SupportedPlatforms,
    cardCalenderBooking,
    cardBookAppointment,
    cardOrder,
    cardFunnel,
  },
  props: {
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      blocks: {},
      toDelete: {},
      dialog: false,
      deleteBlockDialog: false,
      cardsModels: [],
      indexToDelete: -1,
      blocksMapping: [
        { id: 1, slug: "card-text" },
        { id: 2, slug: "card-text" },
        { id: 15, slug: "card-image-url" },
        { id: 3, slug: "card-image" },
        { id: 4, slug: "card-gallery" },
        { id: 5, slug: "card-video" },
        { id: 16, slug: "card-gif" },
        { id: 17, slug: "card-suggested" },
        { id: 18, slug: "card-go-block" },
        { id: 6, slug: "card-audio" },
        { id: 8, slug: "card-typing" },
        { id: 10, slug: "card-attribute" },
        { id: 11, slug: "card-user-input" },
        { id: 12, slug: "card-json" },
        { id: 14, slug: "card-random" },
        { id: 19, slug: "card-billing" },
        { id: 20, slug: "card-travel" },
        { id: 22, slug: "card-flight" },
        { id: 21, slug: "card-weather" },
        { id: 23, slug: "card-multi-input" },
        { id: 24, slug: "card-map" },
        { id: 25, slug: "card-date-time-input" },
        { id: 26, slug: "card-escalate" },
        { id: 27, slug: "card-email" },
        { id: 28, slug: "card-attachment" },
        { id: 29, slug: "card-end-conversation" },
        { id: 30, slug: "card-calender-booking" },
        { id: 31, slug: "card-funnel" },
        { id: 32, slug: "card-order" },
        { id: 33, slug: "card-book-appointment" },
      ],
      blocksDataToUpdate: {},
    };
  },
  computed: {
    selectedBlock() {
      return this.$store.state.blocksBuild.selectedBlock;
    },
    totalErrors() {
      return this.$_.sumBy(this.cardsModels, (m) =>
        m && m.errorsCount ? m.errorsCount : 0
      );
    },
  },
  watch: {
    async selectedBlock(state) {
      if (state) {
        await this.getBlock();
      }
    },
    blocks: {
      handler(val) {
        if (val.id) {
          this.throttleUpdate();
        }
      },
      deep: true,
    },
  },

  methods: {
    async getBlock() {
      this.blocks = {};
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot.get(
        `/blocks/${this.selectedBlock.id}`
      );

      // prepare for cards models
      this.cardsModels = new Array(response.data.payload.length).fill({
        errorsCount: 0,
      });
      this.blocks = response.data;
      this.$store.dispatch("setLoader", false);
    },
    getBlockName(blockId) {
      const index = _.findIndex(this.blocksMapping, (o) => {
        return o.id === blockId;
      });
      if (index !== -1) {
        return this.blocksMapping[index].slug;
      } else {
        return "div";
      }
    },
    setDeleteBlockCard(index) {
      this.dialog = true;
      this.indexToDelete = index;
    },
    deleteBlockCard(index) {
      this.blocks.payload.splice(index, 1);
      this.dialog = false;
    },
    throttleUpdate: common.throttle(async function () {
      await this.updateBlock();
    }, 4000),
    async updateBlock() {
      if (!this.blocksDataToUpdate[this.selectedBlock.id]) {
        this.blocksDataToUpdate[this.selectedBlock.id] = 0;
      }

      const requestId = ++this.blocksDataToUpdate[this.selectedBlock.id];

      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          if (requestId !== this.blocksDataToUpdate[this.selectedBlock.id]) {
            return resolve();
          }

          this.$store.dispatch("setSavingStatus", true);

          try {
            await this.$http.put(`/blocks/${this.selectedBlock.id}`, {
              ...this.blocks,
              errors_count: this.totalErrors,
            });
            resolve();
          } catch (error) {
            reject(error);
          } finally {
            this.$store.dispatch("setSavingStatus", false);
          }
        }, 500);
      });
    },
    deleteBlock() {
      this.$store.dispatch("setDeletedBlock", this.blocks);
      this.deleteBlockDialog = false;
    },
    validCardData(cardData) {
      let validCardData = cards.find((item) => {
        return cardData.block_id === item.block_id;
      });
      if (validCardData) {
        return common.checkDataValid(validCardData.data, cardData.data);
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
